export default function MerchantConcentratorModal({
  open, onClose, merchant, value, onChange, onSave, saving,
}) {
  if (!open || !merchant) return null;
  const setField = (k, v) => onChange({ ...value, [k]: v });

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 border-b" style={{ backgroundColor: '#051C2C' }}>
          <h3 className="text-lg font-bold text-white">Concentradora Propia: {merchant.company_name}</h3>
          <p className="text-xs text-blue-300">
            Si se activa, los flujos de banco (P2P, Débito, BCV, Refund) usan los datos del comercio en vez de los de Caura Pay.
          </p>
        </div>
        <div className="p-6 space-y-4">
          <label className="flex items-center gap-3 p-3 bg-orange-50 rounded-lg border border-orange-200 cursor-pointer">
            <input
              data-testid="conc-toggle"
              type="checkbox"
              checked={value.use_own_concentrator}
              onChange={(e) => setField('use_own_concentrator', e.target.checked)}
              className="w-5 h-5"
            />
            <div>
              <div className="text-sm font-semibold text-gray-900">Activar concentradora propia</div>
              <div className="text-xs text-gray-600">
                Si está desactivada, el comercio usa la concentradora de Caura Pay (comportamiento por default).
              </div>
            </div>
          </label>

          {value.use_own_concentrator && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">RIF del Comercio *</label>
                  <input
                    data-testid="conc-rif"
                    type="text"
                    value={value.rif}
                    onChange={(e) => setField('rif', e.target.value.toUpperCase())}
                    className="w-full px-3 py-2 border rounded-lg text-sm"
                    placeholder="J123456789"
                  />
                  <p className="text-xs text-gray-500 mt-1">Debe ser dueño de la cuenta operativa</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nombre Titular *</label>
                  <input
                    data-testid="conc-titular"
                    type="text"
                    value={value.titular_name}
                    onChange={(e) => setField('titular_name', e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg text-sm"
                    placeholder="EMPRESA X, CA"
                  />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Cuenta Operativa (20 dígitos) *</label>
                  <input
                    data-testid="conc-cuenta"
                    type="text"
                    value={value.cuenta_operativa}
                    onChange={(e) => setField('cuenta_operativa', e.target.value.replace(/\D/g, '').slice(0, 20))}
                    className="w-full px-3 py-2 border rounded-lg text-sm font-mono"
                    placeholder="01340010320100324207"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Banco Cuenta *</label>
                  <input
                    data-testid="conc-cuenta-bank"
                    type="text"
                    value={value.cuenta_bank_code}
                    onChange={(e) => setField('cuenta_bank_code', e.target.value.replace(/\D/g, '').slice(0, 4))}
                    className="w-full px-3 py-2 border rounded-lg text-sm font-mono"
                    placeholder="0134"
                  />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono Pago Móvil *</label>
                  <input
                    data-testid="conc-phone"
                    type="text"
                    value={value.phone_p2p}
                    onChange={(e) => setField('phone_p2p', e.target.value.replace(/\D/g, '').slice(0, 11))}
                    className="w-full px-3 py-2 border rounded-lg text-sm font-mono"
                    placeholder="04141234567"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Banco Tel P2P *</label>
                  <input
                    data-testid="conc-phone-bank"
                    type="text"
                    value={value.phone_bank_code}
                    onChange={(e) => setField('phone_bank_code', e.target.value.replace(/\D/g, '').slice(0, 4))}
                    className="w-full px-3 py-2 border rounded-lg text-sm font-mono"
                    placeholder="0134"
                  />
                </div>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-xs text-yellow-800">
                ⚠️ Al guardar, el backend valida contra Banco Plaza que el RIF sea dueño de la cuenta operativa. Si no coincide, se rechaza con HTTP 400.
              </div>
            </>
          )}
        </div>
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-100">
            Cancelar
          </button>
          <button
            data-testid="conc-save"
            onClick={onSave}
            disabled={saving}
            className="px-4 py-2 text-sm text-white rounded-lg disabled:opacity-50"
            style={{ backgroundColor: '#003594' }}
          >
            {saving ? 'Validando con banco...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
